import React from 'react';
import Formsy from 'formsy-react';
import FormsyInput from '../form/FormsyInput';
import { authAPI } from '../../InterfaceAPI/authAPI';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { stringfyServerErrors } from '../../helpers/util';
import ENV_CONFIG from '../../env';
import withTracker from '../withTracker';

class PasswordForgot extends React.Component {
  state = {
    email: '',
    isValid: false,
    success: false
  };

  render() {
    return (
      <div className="login">
        <div className="login__wrap">
          <h2 className="login__h1">Sign In</h2>
          <h1 className="login__h2">Forgot Password</h1>
          {this.state.isSuccess && (
            <p className="p p--pale-blue">
              Success! Check your email for a link to reset your password.
            </p>
          )}
          {!this.state.isSuccess && (
            <Formsy
              className="login__form"
              onValidSubmit={this.handleSubmit}
              onInvalidSubmit={this.handleInvalidSubmit}
              onValid={this.handleValid}
              onInvalid={this.handleInvalid}
            >
              <div className="form__row">
                <div className="form__row-item form__row-item--full">
                  <FormsyInput
                    type="text"
                    name="email"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    validations="isEmail"
                    required
                  />
                </div>
              </div>

              <div className="form__row">
                <div className="form__row-item form__row-item--full">
                  <button
                    type="submit"
                    className="btn btn--solid-blue btn--full-width"
                    disabled={!this.state.isValid}
                  >
                    Request Password Reset
                  </button>
                </div>
              </div>
            </Formsy>
          )}
        </div>
      </div>
    );
  }

  handleValid = () => this.setState({ isValid: true });
  handleInvalid = () => this.setState({ isValid: false });

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = () => {
    const { role = 'client' } = this.props.match.params;
    const LocalRedirectUrl = `${ENV_CONFIG.REACT_APP_SCHEMA}://${
      document.domain
    }/reset-password/${role}`;

    const payload = {
      role,
      email: this.state.email,
      redirect_url: LocalRedirectUrl //`${ENV_CONFIG.REACT_APP_SCHEMA}://${ENV_CONFIG.REACT_APP_APP_HOST}/reset-password/${role}`,
    };
    authAPI
      .forgotPassword(payload)
      .then(res => this.setState({ isSuccess: true }))
      .catch(err =>
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        })
      );
  };
}

export default withSplashMessage(withTracker(PasswordForgot));



// WEBPACK FOOTER //
// ./src/components/auth/PasswordForgot.js